import { Stack } from '@mui/material';
import { ATSConnectHiringRequestCandidateFeedbackTestIds } from 'data-testids/ATS';
import { GreySecondaryButton } from 'sharedComponents/Buttons/GreySecondaryButton';
import { CandidateFeedbackModalTypes } from '../../../enums';
import {
  CandidateFeedbackModalOption,
  CandidateFeedbackModalPane,
} from '../../../types/feedbackDetailTypes';
import { SecondaryButtonContainer } from '../../../styles/styles';

export interface FeedbackListCTAButtonsProps {
  modalType: CandidateFeedbackModalOption;
  onModalPaneChange: (pane: CandidateFeedbackModalPane) => void;
}

export const FeedbackListCTAButtons: React.FC<FeedbackListCTAButtonsProps> = ({
  modalType,
  onModalPaneChange,
}) => {
  const buttonText =
    modalType === CandidateFeedbackModalTypes.SCORECARD ? '+ Scorecard' : '+  New Reference Check';

  return (
    <Stack direction="row" spacing={2} sx={{ justifyContent: 'flex-end' }}>
      <SecondaryButtonContainer>
        <GreySecondaryButton
          dataTestId={ATSConnectHiringRequestCandidateFeedbackTestIds.ADD_NEW_SCORECARD_BUTTON}
          onClick={() =>
            onModalPaneChange(
              modalType === CandidateFeedbackModalTypes.REFERENCE
                ? { type: 'referenceCreate' }
                : { type: 'scorecardCreate' }
            )
          }
        >
          {buttonText}
        </GreySecondaryButton>
      </SecondaryButtonContainer>
    </Stack>
  );
};
